import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const orderProbabilityListAll = createAsyncThunk('/orderprobability/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getOrderProp(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const orderProbabilitySubListAll = createAsyncThunk('/orderprobability/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getOrderProp(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})




export const orderProbabilitySlice = createSlice({
    name: 'orderProbability',
    initialState,
    reducers: {

        orderProbabilityList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(orderProbabilityListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(orderProbabilityListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(orderProbabilitySubListAll.pending, (state) => {

                state.subloading = false
            })
            .addCase(orderProbabilitySubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
    },
})

export const {
    orderProbabilityList


} = orderProbabilitySlice.actions

export default orderProbabilitySlice.reducer